import { useNavigate } from "react-router-dom";
import BackBtn from "./buttons/BackBtn";

const TopPageBack = ({ onBack, style, children, padHeight, isWhite = false }) => {
  const navigate = useNavigate();

  const onGoBack = () => {
    if (onBack) {
      onBack()
    }
    else {
      navigate(-1)
    }
  }

  // return (
  //   <div
  //     className="sticky top-0 flex justify-center items-center bg-white z-10"
  //     style={{ height: "60px", ...(style || {}) }}
  //   >
  //     <span className="absolute left-4">
  //       <BackBtn onClick={onGoBack} />
  //     </span>
  //     {children}
  //   </div>
  // );
  return (
    <div style={{height: padHeight ?? "60px"}}>
      <div
        className="fixed left-0 w-full top-0 flex justify-center items-center bg-white z-10"
        style={{ height:"60px", ...(style || {}) }}
      >
        <span className="absolute left-4">
          <BackBtn onClick={onGoBack} isWhite={isWhite} />
        </span>
        <span className="text-base">{children}</span>
      </div>
    </div>

  );
};

export default TopPageBack;
